<div *ngIf="!isMsAuthPage">
  <div class="login-page">

    <!-- Logo shown only on small screens -->
    <div class="logo-sm-bar">
      <img alt="Doqfy" class="brand-logo" src="../../../assets/img/new-logo.png" />
    </div>

    <div class="login-grid">

      <!-- ── Left illustration panel ── -->
      <div class="left-panel">
        <div class="divider-line"></div>
      </div>

      <!-- ── Right form panel ── -->
      <div class="right-panel">
        <div class="form-card">

          <div class="form-title">
            Login to Doqfy
          </div>

          <div *ngIf="showInvalid" class="invalid-credential-box" role="alert">
            <i class="pi pi-times-circle invalid-credential-icon"></i>
            <div class="invalid-credential-text">
              <span class="invalid-credential-title">Invalid Credential</span>
              <span class="invalid-credential-subtext">The email or password you entered is incorrect.</span>
            </div>
          </div>

          <form [formGroup]="loginForm">

            <!-- Email -->
            <div class="field-group">
              <label class="field-label" for="doqfyEmail">Email</label>
              <input
                id="doqfyEmail"
                type="email"
                formControlName="email"
                class="form-input"
                pInputText
                autocomplete="off"
                [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
              />
              <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                <div *ngIf="f['email'].errors['required']">Email is required</div>
              </div>
            </div>

            <!-- Password -->
            <div class="field-group">
              <label class="field-label" for="doqfypassword">Password</label>
              <div class="password-wrap">
                <input
                  id="doqfypassword"
                  #input
                  type="password"
                  formControlName="password"
                  class="form-input"
                  pInputText
                  autocomplete="new-password"
                  [ngClass]="{ 'is-invalid': submitted && f['password'].errors }"
                />
                <i class="password-toggle" [ngClass]="icontoDisplay" (click)="toggleFieldTextType(input)"></i>
              </div>
              <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
                <div *ngIf="f['password'].errors['required']">Password is required</div>
              </div>
            </div>

            <!-- Forgot password -->
            <div class="forgot-row">
              <a class="forgot-link" [routerLink]="['/forgot-password']">Forgot Password?</a>
            </div>

            <!-- Terms checkbox -->
            <div class="terms-row">
              <p-checkbox
                class="terms-check"
                formControlName="acceptTerms"
                [binary]="true"
                inputId="termsCheckbox"
              ></p-checkbox>
              <label for="termsCheckbox" class="terms-label">
                By continuing, you agree to Doqfy's
                <a href="https://doqfy.in/terms" target="_blank" class="terms-link">Terms of Services</a>
                and
                <a href="https://doqfy.in/policy" target="_blank" class="terms-link">Privacy Policy</a>
              </label>
            </div>

            <!-- Login button -->
            <button class="login-btn" type="button" (click)="onSubmit()">
              Login
            </button>

            <app-microsoft-auth></app-microsoft-auth>

          </form>
        </div>
      </div>

    </div>

    <p-toast position="top-right" [style]="{ 'margin-top': '10px' }" styleClass="custom-toast"></p-toast>
  </div>

  <!-- OTP modal -->
  <div>
    <ng-template #otpModal let-modal>
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center" style="zoom: 80%">
            <div class="form-signin">
              <div class="radius_border">
                <span style="display: inline-flex; align-items: center; gap: 0.5rem">
                  <img alt="" class="mb-4" style="height: 3rem" src="../../../assets/img/Doqfy Favicon-20241024-053235.png" />
                  <p style="margin: 0; font-size: 20px; font-weight: 600; margin-bottom: 25px;">Doqfy</p>
                </span>
                <div class="container">
                  <div>
                    <span style="font-size: 17px; font-weight: 500">Please enter the verification code sent to</span>
                    <br />
                    <span style="font-size: 17px; font-weight: 600">{{ selectedUserEmail }}</span>
                  </div>
                  <div class="tab-content mt-4" id="pills-tabContent">
                    <div>
                      <div class="otp_section">
                        <ng-otp-input
                          #ngOtpInput
                          (onInputChange)="onOtpChange($event)"
                          *ngIf="showOtpComponent"
                          [config]="config"
                        ></ng-otp-input>
                      </div>
                      <div style="display: inline-flex; float: right; gap: 0.5rem">
                        <div class="font-weight-bold mt-3 cursor" *ngIf="timeLeft !== 0">
                          <span class="resend-otp" style="font-size: 12px; font-weight: 400">Resend verification code</span>
                          <span class="resend-otp-timer" style="font-size: 12px; font-weight: 400; margin-right: 60px"> in {{ timeLeft }} sec</span>
                        </div>
                        <button *ngIf="timeLeft === 0" (click)="resendOtp()" class="resend-btn ms-2">Resend</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="display: flex; justify-content: center; align-items: center;">
                  <div>
                    <button
                      [disabled]="enableOtp"
                      (click)="otpOnSubmit()"
                      class="btn btn-primary"
                      style="background-color: rgb(74,11,119); margin-top: 60px; width: 240px; align-items: center; margin-left: 100px;"
                    >Done</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<div *ngIf="isMsAuthPage">
  <div class="d-flex align-items-center justify-content-center vh-100" style="flex-direction: column">
    <img src="../../../assets/logos/loading_sso_logo.svg" alt="loading_sso_logo" class="logo" style="height: 4rem; margin-bottom: 0" />
    <div class="login-container text-center" style="margin-top: -50px">
      <p class="header_style" style="font-size: 1.2rem; font-weight: 600; margin: 0">Processing Your Login Request</p>
      <p style="font-size: 0.9rem; color: rgb(2 0 31 / 70%); margin: 0">Hang tight... Logging you in!</p>
    </div>
  </div>
</div>
